export default __webpack_public_path__ + "static/media/gift.85e3bc25.svg";